import {
	REQUEST_ACTIVE_USER,
	RECEIVE_ACTIVE_USER,
	ACTIVE_USER_ERROR,
	SET_SESSION_INFO,
	REQUEST_LOGOUT_USER,
	RECEIVE_LOGOUT_USER,
	LOGOUT_USER_ERROR,
	REQUEST_UPDATE_SELF,
	RECEIVE_UPDATE_SELF,
	UPDATE_SELF_ERROR,
	REQUEST_AUTHENTICATE_USER,
	RECEIVE_AUTHENTICATE_USER,
	AUTHENTICATE_USER_ERROR,
} from '../actions/activeUserActions';

import { RECEIVE_UPDATE_USER, RECEIVE_CONFIRM_MAIL } from '../actions/userActionsRedux';

import { RECEIVE_ADD_MODEL } from '../actions/activeModelActions';

const initialActiveUserState = {
	isFetching: false,
	firstRender: true,
	user: {},
	session: {},
	error: null,
};

const activeUserReducer = (state = initialActiveUserState, action) => {
	switch (action.type) {
		case REQUEST_AUTHENTICATE_USER:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_AUTHENTICATE_USER: {
			// sets new state and fetching ended
			const session = { user: action.payload.user, token: action.payload.token };
			return {
				...state,
				user: action.payload.user,
				session,
				firstRender: false,
				isFetching: false,
				error: null,
			};
		}
		case AUTHENTICATE_USER_ERROR:
			// fetching ended and error is being set
			return {
				...state,
				user: initialActiveUserState.user,
				session: initialActiveUserState.session,
				error: action.payload,
				isFetching: false,
			};
		case REQUEST_ACTIVE_USER:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, firstRender: false, error: null };
		case RECEIVE_ACTIVE_USER:
			// sets new state and fetching ended
			return { ...state, user: action.payload, isFetching: false, error: null };
		case ACTIVE_USER_ERROR:
			// fetching ended and error is being set
			return { ...state, user: initialActiveUserState.user, error: action.payload, isFetching: false };
		case SET_SESSION_INFO:
			// sets new state and fetching ended
			return { ...state, session: action.payload, error: null };
		case RECEIVE_LOGOUT_USER:
			// sets new state and fetching ended
			return { ...initialActiveUserState, firstRender: false };
		case LOGOUT_USER_ERROR:
			// sets new state and fetching ended
			return initialActiveUserState;
		case REQUEST_LOGOUT_USER:
			// sets new state and fetching ended
			return { ...state, isFetching: true, error: null };
		case REQUEST_UPDATE_SELF:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_UPDATE_SELF:
			// sets new state and fetching ended
			return {
				...state,
				user: { ...state.user, ...action.payload },
				isFetching: false,
				error: null,
			};
		case UPDATE_SELF_ERROR:
			// fetching ended and error is being set
			return { ...state, user: state.user, error: action.payload, isFetching: false };
		case RECEIVE_ADD_MODEL:
			return { ...state, user: { ...state.user, modelAccess: [...state.user.modelAccess, action.payload.slug] } };
		case RECEIVE_UPDATE_USER:
			return { ...state, user: action.payload._id === state.user._id ? action.payload : state.user };
		case RECEIVE_CONFIRM_MAIL: {
			// if the confirmed mail user is the active user we change the name/mail to the new one
			const confirmedUser = state.user;
			if (action.payload.oldName === state.user.name) {
				confirmedUser.name = action.payload.newName;
			}
			return { ...state, user: { ...confirmedUser }, isFetching: false, error: null };
		}
		default:
			return state;
	}
};

export default activeUserReducer;
